import { useRef, useState } from "react";
import { Upload, Loader2, ImageIcon } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr, resolveImg } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

export default function ImageUpload({ value, onChange, label = "الصورة" }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    const form = new FormData();
    form.append("file", file);
    try {
      const { data } = await api.post("/admin/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("تم رفع الصورة");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <label className="mb-1.5 block text-sm font-medium">{label}</label>
      <div className="flex items-center gap-3">
        <div className="h-16 w-16 rounded-xl bg-muted overflow-hidden grid place-items-center shrink-0">
          {value ? <img src={resolveImg(value)} alt="" className="h-full w-full object-cover" /> : <ImageIcon className="h-6 w-6 text-muted-foreground" />}
        </div>
        <div className="flex-1 space-y-2">
          <Input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="رابط الصورة أو ارفعي صورة" className="rounded-xl h-10 text-sm" dir="ltr" />
          <input type="file" accept="image/*" ref={ref} onChange={upload} className="hidden" />
          <Button type="button" variant="outline" size="sm" onClick={() => ref.current?.click()} disabled={busy} className="rounded-full border-2">
            {busy ? <Loader2 className="h-4 w-4 animate-spin me-1" /> : <Upload className="h-4 w-4 me-1" />} رفع صورة
          </Button>
        </div>
      </div>
    </div>
  );
}
